import { OrderTemplate } from '../../model/order-template';
import OrderTemplateModals from './order-template-modals';

export default class OrderTemplateItem {

  private readonly orderTemplate: OrderTemplate;
  private readonly openDuplicateOrderTemplateModal: JQuery;
  private readonly openDeleteOrderTemplateModal: JQuery;

  constructor(private container: JQuery, private modals: OrderTemplateModals) {
    this.orderTemplate = new OrderTemplate(container.data('order-template-code'));

    this.openDuplicateOrderTemplateModal = container.find('.js-openDuplicateOrderTemplateModal');
    this.openDeleteOrderTemplateModal = container.find('.js-openDeleteOrderTemplateModal');

    this.bindOpenDuplicateOrderTemplateModal();
    this.bindOpenDeleteOrderTemplateModal();
  }

  private bindOpenDuplicateOrderTemplateModal(): void {
    this.openDuplicateOrderTemplateModal.on('click', () => {
      this.modals.bindOpenDuplicateModal(this.orderTemplate);
    });
  }

  private bindOpenDeleteOrderTemplateModal(): void {
    this.openDeleteOrderTemplateModal.on('click', () => {
      this.modals.bindOpenDeleteModal(this.orderTemplate);
    });
  }
}
